import { dashboardApi } from '@/api';
import { queryOptions } from '@tanstack/react-query';

interface ReportsQueryArgs {
    projectId: string;
    dashboardId: string;
}

export type ReportsQueryResponse = {
    id: string;
    fileSize: number;
    fileName: string;
    extension: string;
}[];

const getReportsQuery = async ({ projectId, dashboardId }: ReportsQueryArgs) =>
    dashboardApi<ReportsQueryResponse>({
        method: 'GET',
        url: `/front-office/project/${projectId}/dashboard/${dashboardId}/reports`,
    });

export const getReportsQueryOptions = ({
    projectId,
    dashboardId,
}: ReportsQueryArgs) =>
    queryOptions({
        queryKey: ['reports-list', projectId, dashboardId],
        queryFn: () => getReportsQuery({ projectId, dashboardId }),
        enabled: !!projectId && !!dashboardId,
    });
